import { render, staticRenderFns } from "./DataPermissions.vue?vue&type=template&id=1a342854&scoped=true"
import script from "./DataPermissions.vue?vue&type=script&lang=js"
export * from "./DataPermissions.vue?vue&type=script&lang=js"
import style0 from "./DataPermissions.vue?vue&type=style&index=0&id=1a342854&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a342854",
  null
  
)

export default component.exports